export default __webpack_public_path__ + "static/contact-the-customer-service~bfqnRTBe-5c3a667a3f78bc7746551e1cc405f671.jpg";